import { removeHTMLTagsRegEx } from '@/constants/regularExpressions';

export const getInnerText = (html) => (html || '').replaceAll(removeHTMLTagsRegEx, '');

export const getFileName = (url) => (url || '').split('/').pop();

export const fileNameToDisplay = (url) => {
  const name = getFileName(url);

  if (name.length > 22) {
    return `${name.slice(0, 10)}...${name.slice(-10)}`;
  }

  return name;
};
